import {SET_LOADING, UPDATE_PARTNER,SET_CONNECTIONS, SET_PARTNERS, SET_PENDING_PARTNERS} from 'store/reducers/connectionsReducer'
import { apiRequest } from 'util/api/util'
import _ from 'lodash'

const removeEmpty = (obj) => {
    Object.keys(obj).forEach(key => {
        if (obj[key] && typeof obj[key] === 'object') removeEmpty(obj[key]);
        else if (obj[key] === undefined) delete obj[key];
    });
    return obj;
};

export const approveInvitation = (connection, onFinished) => {
    return async (dispatch, getState, { getFirebase, getFirestore }) => {

        // setTimeout(function() {
        //     dispatch({type: UPDATE_PARTNER, partner: {
        //         ...connection,
        //         verified: true
        //         // status: ""
        //     }})
        //     onFinished()
        // }, 2000)
        return apiRequest(`connections/approve?connectionId=${connection.id}`, "POST")
            .then(result => {
                dispatch({type: UPDATE_PARTNER, partner: {
                    ...connection,
                    verified: true
                    // status: ""
                }})
                onFinished()
            })
            .catch(err => {
                window.alert("Error approving connection: ", err)
                onFinished()
            }) 
    }
}

export const loadInvitations = (partnerId) => {
    return async (dispatch, getState, { getFirebase, getFirestore }) => {

        console.log("Loading invitations: ", partnerId)
        return apiRequest(`connections/pendingInvitations?partnerId=${partnerId}`)
            .then(results => {
                results = results.map(val => {
                    return {
                        ...val,
                        // status: val.verified ? "connected" : "pending"
                    }
                })
                console.log(results)
                // setInvitations(results)
                dispatch({type: SET_PENDING_PARTNERS, pendingPartners: results})
            })
            .catch(err => {
                console.log(err)
            })
    }
}

export const loadConnections = (partnerId) => {
    return async (dispatch, getState, { getFirebase, getFirestore }) => {

        dispatch({type: SET_LOADING, isLoading: true})
        console.log("Loading loadConnections: ", partnerId)
        return apiRequest(`connections/get?partnerId=${partnerId}`)
            .then(results => {
                if (results?.connections) {
                    const resultConnections = results.connections.map(val => {
                        return {
                            ...val,
                            // status: val.verified ? "connected" : "pending"
                        }
                    })
                    console.log("resultConnections: ", resultConnections)
                    // setConnections(resultConnections)
                    dispatch({type: SET_CONNECTIONS, connections: resultConnections})
                }

                if (results?.partners) {
                    const resultPartners = results.partners.map(val => {
                        return {
                            ...val,
                            // status: val.verified ? "connected" : "pending"
                        }
                    })
                    console.log("resultPartners: ", resultPartners)
                    // setPartners(resultPartners)
                    dispatch({type: SET_PARTNERS, partners: resultPartners})
                }
                dispatch({type: SET_LOADING, isLoading: false})
            })
            .catch(err => {
                console.log(err)
            })

        // dispatch({type: SET_CLIENTS_LOADING, isLoading: true})

        // const firestore = getFirestore();
        // firestore.collection("instructor_dashboards").doc(userId).collection("clients").get()
        //     .then(snapshot => {
        //         // TODO set reservations

        //         var clients = snapshotToObjects(snapshot).filter(val => !val.removed)
                
        //         dispatch({ type: SET_CLIENTS, clients: clients })
        //         dispatch({type: SET_CLIENTS_LOADING, isLoading: false})
        //     })
        //     .catch( err => {
        //         console.log("Error getting client data: " + err)
        //     })
    }
}

// export const deleteClient = (data) => {
//     return async (dispatch, getState, { getFirebase, getFirestore }) => {

//         if (!data.platformID) {
//             dispatch({type: SET_CLIENTS_ERROR, error: "Unable to remove this client" })
//             return 
//         }

//         const state = getState();
//         const userId = state.user.userData.platformID

//         // dispatch({type: SET_CLIENTS_SAVING, isSaving: true })

//         const firestore = getFirestore();

//         return new Promise(async (resolve, reject) => {

//             try {

//                 await firestore
//                     .collection("instructor_dashboards")
//                     .doc(userId).collection("clients")
//                     .doc(data.platformID).update({
//                         removed: true
//                     })
                
//                 // var clients = {...state.clients.clients}
//                 // console.log(clients)
//                 // _.remove(clients, val => val.platformID === data.platformID);

//                 const clients = _.filter(state.clients.clients, function(x) { return x?.platformID !== data?.platformID; });
//                 // _.reject(state.clients, function(el) {
//                 //     return el?.platformID === data?.platformID
//                 //  });

//                  console.log(clients)
//                 // state.clients.filter(function(el) { return el.platformID !== data.platformID; });
//                 dispatch({ type: SET_CLIENTS, clients: clients })
                

//                 // data.platformID = newRef.id
//                 // dispatch({type: ADDED_NEW_CLIENT, newClient: data})
//                 // dispatch({type: SET_CLIENTS_SAVING, isSaving: false })
//                 // dispatch({type: SET_CLIENTS_SAVING_ERROR, savingError: null })
//                 resolve("Done")
//             } catch (err) {
//                 dispatch({type: SET_CLIENTS_ERROR, error: "Unable to remove this client" })
//                 // dispatch({type: SET_CLIENTS_SAVING, isSaving: false })
//                 // dispatch({type: SET_CLIENTS_SAVING_ERROR, savingError: "Something went wrong, please try again" })
//                 reject(err)
//                 console.log(`Error removing client: ${err}`)
//             }
//         })
//     }
// }

// export const addNewClient = (data) => {
//     return async (dispatch, getState, { getFirebase, getFirestore }) => {

//         removeEmpty(data)

//         const state = getState();
//         const userId = state.user.userData.platformID

//         dispatch({type: SET_CLIENTS_SAVING, isSaving: true })

//         const firestore = getFirestore();

//         return new Promise(async (resolve, reject) => {

//             try {

//                 const newRef = await firestore.collection("instructor_dashboards").doc(userId).collection("clients").add(data)
//                 data.platformID = newRef.id
//                 dispatch({type: ADDED_NEW_CLIENT, newClient: data})
//                 dispatch({type: SET_CLIENTS_SAVING, isSaving: false })
//                 dispatch({type: SET_CLIENTS_SAVING_ERROR, savingError: null })
//                 resolve("Done")
//             } catch (err) {
//                 dispatch({type: SET_CLIENTS_SAVING, isSaving: false })
//                 dispatch({type: SET_CLIENTS_SAVING_ERROR, savingError: "Something went wrong, please try again" })
//                 reject(err)
//                 console.log(`Error saving new client: ${err}`)
//             }
//         })
//     }

    
// }